import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * Flow Map 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFlowMapData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-map-data.do`, params);
  },
  /**
   * Flow 추이 차트 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getFlowChartData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-chart-data.do`, params);
  },
  /**
   * Flow Map을 조회할 장비/인터페이스 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getFlowMapDeviceList() {
    return axios.get(`${baseUrl}/performance/flow/get-flow-map-device-list.do`);
  },
  /**
   * Flow Map의 특정 장비의 Top1 인터페이스 번호 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFlowMapInterfaceList(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-map-interface-list.do`, params);
  },
  /**
   * 특정 Flow에 대한 상세정보 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFlowMapDetailInfo(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-detail-info.do`, params);
  },
  /**
   * 스마트 추적 IP 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getIpSmartTraceData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-ip-smart-trace-data.do`, params);
  },
  /**
   * 스마트 추적 프로토콜 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getProtocolSmartTraceData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-protocol-smart-trace-data.do`, params);
  },
  /**
   * 스마트 추적 서비스포트 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getPortSmartTraceData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-port-smart-trace-data.do`, params);
  },
  /**
   * 스마트 추적 인터페이스 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getInterfaceSmartTraceData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-netinterface-smart-trace-data.do`, params);
  },
  /**
   * Flow분석할 관리대상을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getBasicFilter(params) {
    return axios.post(`${baseUrl}/performance/flow/get-basic-filter.do`, params);
  },
  /**
   * 스마트 추적에 따라 트래픽 목록을 조회한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFlowTrafficList(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-traffic-list.do`, params);
  },
  /**
   * flow 분석 > 트래픽 목록의 엑셀 출력을 수행한다.
   * @author yelim
   */
  createFlowTrafficExcel(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-traffic-excel-name.do`, params);
  },
  /**
   * 스마트 추적 Conversation 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getConversationSmartTraceData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-conversation-smart-trace-data.do`, params);
  },
  /**
   * 과거 이력 그래프 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getFlowHistChartData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-hist-chart-data.do`, params);
  },
  /**
   * 과거이력 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getFlowHistData(params) {
    return axios.post(`${baseUrl}/performance/flow/get-flow-hist-data.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/flow-analysis/flow-analysis.js